import { X } from 'lucide-react';
import { twMerge } from 'tailwind-merge';

interface ModalCloseButtonProps {
  onClick: () => void;
  /** Ignored clicks while a save is in flight; the button stays focusable. */
  disabled?: boolean;
  className?: string;
}

/** The one close control for Modal and Drawer: 44px hit area, focus ring (DESIGN.md §10.2). */
export function ModalCloseButton({ onClick, disabled = false, className }: ModalCloseButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Close"
      aria-disabled={disabled || undefined}
      title="Close"
      className={twMerge(
        'focus-ring flex size-11 shrink-0 items-center justify-center rounded-full bg-gray-100 text-gray-400 transition-colors hover:bg-gray-200 hover:text-gray-700 aria-disabled:cursor-not-allowed aria-disabled:opacity-50 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white',
        className,
      )}
    >
      <X className="size-6" aria-hidden="true" />
    </button>
  );
}
